/* ============================================
   HEIR LONDON - RING SIZE GUIDE
   Interactive JavaScript Functionality
   For page.home-new template
   ============================================ */

// ============================================
// Ring Size Conversion Data
// ============================================
const ringSizeData = [
    { circumference: [40, 44], ukSize: 'H', usSize: '4', diameter: 12.7 },
    { circumference: [44, 45], ukSize: 'I', usSize: '4.5', diameter: 14.1 },
    { circumference: [45, 46], ukSize: 'J', usSize: '5', diameter: 14.5 },
    { circumference: [46, 47], ukSize: 'K', usSize: '5.5', diameter: 14.9 },
    { circumference: [47, 49], ukSize: 'L', usSize: '6', diameter: 15.3 },
    { circumference: [49, 50], ukSize: 'M', usSize: '6.5', diameter: 15.7 },
    { circumference: [50, 52], ukSize: 'N', usSize: '7', diameter: 16.1 },
    { circumference: [52, 53], ukSize: 'O', usSize: '7.5', diameter: 16.5 },
    { circumference: [53, 55], ukSize: 'P', usSize: '7.5-8', diameter: 17.0 },
    { circumference: [55, 56], ukSize: 'Q', usSize: '8', diameter: 17.3 },
    { circumference: [56, 58], ukSize: 'Q', usSize: '8.5', diameter: 17.7 },
    { circumference: [58, 59], ukSize: 'R', usSize: '9', diameter: 18.2 },
    { circumference: [59, 61], ukSize: 'S', usSize: '9.5', diameter: 18.6 },
    { circumference: [61, 62], ukSize: 'S', usSize: '9.5', diameter: 19.0 },
    { circumference: [62, 63], ukSize: 'T', usSize: '10', diameter: 19.4 },
    { circumference: [63, 64], ukSize: 'U', usSize: '10.5', diameter: 19.8 },
    { circumference: [64, 65], ukSize: 'V', usSize: '11', diameter: 20.2 },
    { circumference: [65, 67], ukSize: 'W', usSize: '11.5', diameter: 20.6 },
    { circumference: [67, 68], ukSize: 'X', usSize: '12', diameter: 21.0 },
    { circumference: [68, 69], ukSize: 'Y', usSize: '12.5', diameter: 21.4 },
    { circumference: [69, 70], ukSize: 'Z', usSize: '13', diameter: 21.8 },
    { circumference: [70, 72], ukSize: 'Z+1', usSize: '13.5', diameter: 22.2 },
    { circumference: [72, 74], ukSize: 'Z+2', usSize: '14', diameter: 22.6 },
    { circumference: [74, 76], ukSize: 'Z+3', usSize: '14.5', diameter: 23.0 }
];

// ============================================
// Wait for DOM to be ready
// ============================================
function domReady(fn) {
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', fn);
    } else {
        fn();
    }
}

domReady(function() {
    // ============================================
    // DOM Elements
    // ============================================
    const elements = {
        sizeCalculatorForm: document.getElementById('sizeCalculator'),
        fingerCircumference: document.getElementById('fingerCircumference'),
        calculatorResult: document.getElementById('calculatorResult'),
        ukSize: document.getElementById('ukSize'),
        usSize: document.getElementById('usSize'),
        diameter: document.getElementById('diameter'),
        shopSize: document.getElementById('shopSize'),
        freeSizerForm: document.getElementById('freeSizerForm'),
        sizerFormSuccess: document.getElementById('sizerFormSuccess'),
        downloadPdfBtn: document.getElementById('downloadPdfBtn'),
        liveChatBtn: document.getElementById('liveChatBtn'),
        exitPopup: document.getElementById('exitPopup'),
        closePopup: document.getElementById('closePopup'),
        skipPopup: document.getElementById('skipPopup'),
        popupCta: document.getElementById('popupCta'),
        faqItems: document.querySelectorAll('.faq-item')
    };

    // ============================================
    // Ring Size Calculator
    // ============================================
    function calculateRingSize(circumference) {
        const circ = parseFloat(circumference);
        
        // Find matching size
        for (let size of ringSizeData) {
            if (circ >= size.circumference[0] && circ < size.circumference[1]) {
                return size;
            }
        }
        
        // If outside range, return closest
        if (circ < ringSizeData[0].circumference[0]) {
            return ringSizeData[0];
        }
        
        return ringSizeData[ringSizeData.length - 1];
    }

    // Calculator Form Handler
    if (elements.sizeCalculatorForm) {
        elements.sizeCalculatorForm.addEventListener('submit', function(e) {
            e.preventDefault();
            
            const circumference = elements.fingerCircumference.value;
            
            if (!circumference || circumference < 40 || circumference > 80) {
                alert('Please enter a valid measurement between 40mm and 80mm');
                return;
            }
            
            const result = calculateRingSize(circumference);
            
            // Display results
            if (elements.ukSize) elements.ukSize.textContent = result.ukSize;
            if (elements.usSize) elements.usSize.textContent = result.usSize;
            if (elements.diameter) elements.diameter.textContent = result.diameter + 'mm';
            if (elements.shopSize) elements.shopSize.textContent = result.ukSize;
            
            // Show result container
            if (elements.calculatorResult) {
                elements.calculatorResult.style.display = 'block';
                // Smooth scroll to result
                elements.calculatorResult.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
                
                // Add animation
                elements.calculatorResult.style.animation = 'none';
                setTimeout(() => {
                    elements.calculatorResult.style.animation = 'fadeIn 0.5s ease';
                }, 10);
            }
            
            // Track conversion (analytics would go here)
            console.log('Ring size calculated:', result);
        });
    }

    // ============================================
    // Free Ring Sizer Form Handler
    // ============================================
    if (elements.freeSizerForm) {
        elements.freeSizerForm.addEventListener('submit', function(e) {
            e.preventDefault();
            
            // Get form data
            const formData = {
                name: document.getElementById('sizerName') ? document.getElementById('sizerName').value : '',
                email: document.getElementById('sizerEmail') ? document.getElementById('sizerEmail').value : '',
                address: document.getElementById('sizerAddress') ? document.getElementById('sizerAddress').value : '',
                address2: document.getElementById('sizerAddress2') ? document.getElementById('sizerAddress2').value : '',
                city: document.getElementById('sizerCity') ? document.getElementById('sizerCity').value : '',
                postcode: document.getElementById('sizerPostcode') ? document.getElementById('sizerPostcode').value : ''
            };
            
            // Validate
            if (!formData.name || !formData.email || !formData.address || !formData.city || !formData.postcode) {
                alert('Please fill in all required fields');
                return;
            }
            
            // In production, this would send to server
            console.log('Ring sizer request:', formData);
            
            // Simulate API call
            setTimeout(() => {
                // Hide form, show success message
                if (elements.freeSizerForm) elements.freeSizerForm.style.display = 'none';
                if (elements.sizerFormSuccess) {
                    elements.sizerFormSuccess.style.display = 'block';
                    // Scroll to success message
                    elements.sizerFormSuccess.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
                
                // Track conversion
                console.log('Free ring sizer requested successfully');
                
                // In production: Send email, add to CRM, etc.
            }, 500);
        });
    }

    // ============================================
    // Download PDF Handler
    // ============================================
    if (elements.downloadPdfBtn) {
        elements.downloadPdfBtn.addEventListener('click', function() {
            // In production, this would download actual PDF
            alert('📥 Printable Ring Sizer PDF\n\nIn production, this would download a professionally designed PDF ring sizer.\n\nThe PDF would include:\n✓ Paper strip sizer\n✓ Ring measuring circles\n✓ Verification ruler\n✓ Step-by-step instructions');
            
            // Track download
            console.log('Ring sizer PDF download initiated');
            
            // In production:
            // window.location.href = '/downloads/heir-ring-sizer.pdf';
        });
    }

    // ============================================
    // FAQ Accordion
    // ============================================
    if (elements.faqItems && elements.faqItems.length > 0) {
        elements.faqItems.forEach(item => {
            const question = item.querySelector('.faq-question');
            
            if (question) {
                question.addEventListener('click', function() {
                    // Close all other items
                    elements.faqItems.forEach(otherItem => {
                        if (otherItem !== item) {
                            otherItem.classList.remove('active');
                        }
                    });
                    
                    // Toggle current item
                    item.classList.toggle('active');
                });
            }
        });
    }

    // ============================================
    // Smooth Scroll Navigation
    // ============================================
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function(e) {
            const targetId = this.getAttribute('href');
            if (targetId === '#' || !targetId) return;
            
            const targetElement = document.querySelector(targetId);
            
            if (targetElement) {
                e.preventDefault();
                const offset = 80; // Account for sticky nav
                const targetPosition = targetElement.offsetTop - offset;
                
                window.scrollTo({
                    top: targetPosition,
                    behavior: 'smooth'
                });
            }
        });
    });
    // ============================================
    // Exit Intent Popup
    // ============================================
    let exitPopupShown = false;
    let exitPopupEnabled = true;

    function showExitPopup() {
        if (!exitPopupShown && exitPopupEnabled) {
            elements.exitPopup.classList.add('active');
            exitPopupShown = true;
            document.body.classList.add('open--popup');
            document.body.style.overflow = 'hidden';
            
            // Track popup display
            console.log('Exit popup displayed');
        }
    }

    function hideExitPopup() {
        elements.exitPopup.classList.remove('active');
        document.body.classList.remove('open--popup');
        document.body.style.overflow = '';
    }

    // Detect exit intent (mouse leaving viewport at top)
    document.addEventListener('mouseleave', function(e) {
        if (e.clientY < 10) {
            showExitPopup();
        }
    });

    // Close popup handlers
    if (elements.closePopup) {
        elements.closePopup.addEventListener('click', hideExitPopup);
    }

    if (elements.skipPopup) {
        elements.skipPopup.addEventListener('click', hideExitPopup);
    }

    if (elements.popupCta) {
        elements.popupCta.addEventListener('click', function() {
            hideExitPopup();
            // Scroll handled by smooth scroll function
        });
    }

    // Close on overlay click
    if (elements.exitPopup) {
        elements.exitPopup.addEventListener('click', function(e) {
            if (e.target === elements.exitPopup) {
                hideExitPopup();
            }
        });
    }

    // Close on ESC key
    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && elements.exitPopup.classList.contains('active')) {
            hideExitPopup();
        }
    });

    // Disable exit popup after user has been on page for 30 seconds
    setTimeout(() => {
        exitPopupEnabled = false;
    }, 30000);
    // ============================================
    // Live Chat Handler
    // ============================================
    if (elements.liveChatBtn) {
        elements.liveChatBtn.addEventListener('click', function() {
            // In production, this would open actual live chat
            alert('💬 Live Chat\n\nIn production, this would open a live chat window with Heir London support team.\n\nAvailable: Mon-Fri, 9am-6pm GMT\n\nFor demo purposes, please use the contact information provided or email sizing@heirlondon.co.uk');
            
            // Track click
            console.log('Live chat initiated');
            
            // In production: Open live chat widget
            // window.LiveChat.open();
        });
    }

    // ============================================
    // Active Navigation Highlight
    // ============================================
    const sections = document.querySelectorAll('.method-section, .charts-section, .tips-section');
    const navLinks = document.querySelectorAll('.nav-link');

    function highlightNavigation() {
        const scrollPos = window.scrollY + 100;
        
        sections.forEach(section => {
            const sectionTop = section.offsetTop;
            const sectionHeight = section.offsetHeight;
            const sectionId = section.getAttribute('id');
            
            if (scrollPos >= sectionTop && scrollPos < sectionTop + sectionHeight) {
                navLinks.forEach(link => {
                    link.style.color = '';
                    if (link.getAttribute('href') === `#${sectionId}`) {
                        link.style.color = 'var(--color-primary)';
                    }
                });
            }
        });
    }

    window.addEventListener('scroll', highlightNavigation);

    // ============================================
    // Form Validation Enhancement
    // ============================================
    function addFormValidation() {
        const inputs = document.querySelectorAll('input[required]');
        
        inputs.forEach(input => {
            // Real-time validation feedback
            input.addEventListener('blur', function() {
                if (!this.value) {
                    this.style.borderColor = 'var(--color-error)';
                } else {
                    this.style.borderColor = 'var(--color-success)';
                }
            });
            
            input.addEventListener('input', function() {
                if (this.value) {
                    this.style.borderColor = 'var(--color-border)';
                }
            });
        });
    }

    addFormValidation();

    // ============================================
    // Intersection Observer for Animations
    // ============================================
    const observerOptions = {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver(function(entries) {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.style.opacity = '1';
                entry.target.style.transform = 'translateY(0)';
            }
        });
    }, observerOptions);

    // Observe elements for fade-in animation
    const animatedElements = document.querySelectorAll('.method-card, .size-card, .support-card, .guarantee-item, .faq-item');

    animatedElements.forEach(el => {
        el.style.opacity = '0';
        el.style.transform = 'translateY(20px)';
        el.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
        observer.observe(el);
    });

    // ============================================
    // Scroll Progress Indicator
    // ============================================
    const progressBar = document.createElement('div');
    progressBar.style.cssText = `
        position: fixed;
        top: 0;
        left: 0;
        height: 3px;
        background: linear-gradient(90deg, var(--color-primary) 0%, var(--color-primary-light) 100%);
        z-index: 10001;
        transition: width 0.1s ease;
        width: 0;
    `;
    document.body.appendChild(progressBar);

    function updateProgressBar() {
        const windowHeight = window.innerHeight;
        const documentHeight = document.documentElement.scrollHeight;
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const scrollPercentage = (scrollTop / (documentHeight - windowHeight)) * 100;
        
        progressBar.style.width = Math.min(scrollPercentage, 100) + '%';
    }

    window.addEventListener('scroll', updateProgressBar);
    updateProgressBar();

    // ============================================
    // Copy to Clipboard Functionality
    // ============================================
    function addCopyButtons() {
        const tables = document.querySelectorAll('.size-table');
        
        tables.forEach(table => {
            // Check if button already exists
            if (table.parentElement.querySelector('.copy-size-chart-btn')) return;
            
            const copyBtn = document.createElement('button');
            copyBtn.className = 'btn-secondary copy-size-chart-btn';
            copyBtn.innerHTML = '<i class="fas fa-copy"></i> Copy Size Chart';
            copyBtn.style.marginTop = '1rem';
            copyBtn.type = 'button';
            
            copyBtn.addEventListener('click', function() {
                let textContent = '';
                const rows = table.querySelectorAll('tr');
                
                rows.forEach(row => {
                    const cells = row.querySelectorAll('th, td');
                    const rowText = Array.from(cells).map(cell => cell.textContent.trim()).join(' | ');
                    textContent += rowText + '\n';
                });
                
                if (navigator.clipboard && navigator.clipboard.writeText) {
                    navigator.clipboard.writeText(textContent).then(() => {
                        copyBtn.innerHTML = '<i class="fas fa-check"></i> Copied!';
                        copyBtn.style.background = 'var(--color-success)';
                        
                        setTimeout(() => {
                            copyBtn.innerHTML = '<i class="fas fa-copy"></i> Copy Size Chart';
                            copyBtn.style.background = '';
                        }, 2000);
                    }).catch(() => {
                        alert('Failed to copy. Please select and copy manually.');
                    });
                } else {
                    // Fallback for older browsers
                    const textarea = document.createElement('textarea');
                    textarea.value = textContent;
                    textarea.style.position = 'fixed';
                    textarea.style.opacity = '0';
                    document.body.appendChild(textarea);
                    textarea.select();
                    try {
                        document.execCommand('copy');
                        copyBtn.innerHTML = '<i class="fas fa-check"></i> Copied!';
                        setTimeout(() => {
                            copyBtn.innerHTML = '<i class="fas fa-copy"></i> Copy Size Chart';
                        }, 2000);
                    } catch (err) {
                        alert('Failed to copy. Please select and copy manually.');
                    }
                    document.body.removeChild(textarea);
                }
            });
            
            table.parentElement.appendChild(copyBtn);
        });
    }

    // Add copy buttons after page load
    //setTimeout(addCopyButtons, 500);

    // ============================================
    // Analytics Tracking (placeholder)
    // ============================================
    function trackEvent(category, action, label) {
        console.log('Analytics Event:', { category, action, label });
        
        // In production, integrate with Google Analytics, Meta Pixel, etc:
        // if (typeof gtag !== 'undefined') {
        //     gtag('event', action, { 'event_category': category, 'event_label': label });
        // }
        // if (typeof fbq !== 'undefined') {
        //     fbq('track', action, { category, label });
        // }
    }

    // Track key user interactions
    document.querySelectorAll('.method-card').forEach(card => {
        card.addEventListener('click', function() {
            const methodTitle = this.querySelector('h3');
            if (methodTitle) {
                const method = methodTitle.textContent;
                trackEvent('Sizing Method', 'Select Method', method);
            }
        });
    });

    // ============================================
    // Print Optimization
    // ============================================
    window.addEventListener('beforeprint', function() {
        // Expand all FAQ items for printing
        if (elements.faqItems && elements.faqItems.length > 0) {
            elements.faqItems.forEach(item => {
                item.classList.add('active');
            });
        }
    });

    window.addEventListener('afterprint', function() {
        // Collapse FAQ items after printing
        if (elements.faqItems && elements.faqItems.length > 0) {
            elements.faqItems.forEach(item => {
                item.classList.remove('active');
            });
        }
    });

    // ============================================
    // Keyboard Navigation Enhancement
    // ============================================
    document.addEventListener('keydown', function(e) {
        // Alt + 1-5 for quick method navigation
        if (e.altKey) {
            const methodIds = ['method1', 'method2', 'method3', 'method4', 'method5'];
            const keyIndex = parseInt(e.key) - 1;
            
            if (keyIndex >= 0 && keyIndex < methodIds.length) {
                const methodElement = document.getElementById(methodIds[keyIndex]);
                if (methodElement) {
                    methodElement.scrollIntoView({ behavior: 'smooth' });
                }
            }
        }
    });

    // ============================================
    // Session Storage for Form Persistence
    // ============================================
    function saveFormData() {
        const forms = document.querySelectorAll('form');
        
        forms.forEach(form => {
            const inputs = form.querySelectorAll('input');
            
            inputs.forEach(input => {
                input.addEventListener('input', function() {
                    if (this.id) {
                        sessionStorage.setItem(this.id, this.value);
                    }
                });
                
                // Restore saved data
                if (input.id) {
                    const savedValue = sessionStorage.getItem(input.id);
                    if (savedValue) {
                        input.value = savedValue;
                    }
                }
            });
        });
    }

    saveFormData();

    // Clear session storage on successful submission
    document.querySelectorAll('form').forEach(form => {
        form.addEventListener('submit', function() {
            setTimeout(() => {
                sessionStorage.clear();
            }, 1000);
        });
    });

    // ============================================
    // Fade-in animation CSS
    // ============================================
    const style = document.createElement('style');
    style.textContent = `
        @keyframes fadeIn {
            from { opacity: 0; transform: translateY(-10px); }
            to { opacity: 1; transform: translateY(0); }
        }
    `;
    document.head.appendChild(style);

    // ============================================
    // Initialize
    // ============================================
    console.log('Heir London Ring Size Guide initialized');
    console.log('Version: 1.0.0 - Home New Template');
    
    // Track page load
    trackEvent('Page', 'Load', 'Ring Size Guide - Home New');
    
    // ============================================
    // Console welcome message
    // ============================================
    console.log('%c🏆 HEIR LONDON', 'font-size: 20px; font-weight: bold; color: #D4AF37;');
    console.log('%cHandcrafted in Hatton Garden, London', 'font-size: 12px; color: #999;');
    console.log('%cRing Size Guide v1.0.0', 'font-size: 12px; color: #999;');
});
